import { useIntl } from "react-intl";

import ImageChecklistSide, {
    ListItemWithEmphsis
} from "../../../../../../../../patterns/image-checklist-side";

const MarketingTeams = () => {
    const intl = useIntl();

    const title = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.headerText",
        defaultMessage: "Marketing teams"
    });

    const manageProjects = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.manageProjects.strongtext",
            defaultMessage: "Manage projects any way you want:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.manageProjects.plainText",
            defaultMessage:
                " Launch campaigns with ease. Use the timeline, list, or calendar views to map dependencies, track progress, and make decisions quickly. From your boss to colleagues, everyone can stay on top of important milestones."
        })
    };

    const customForm = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.customForm.strongtext",
            defaultMessage: "Set up a custom form in seconds:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.customForm.plainText",
            defaultMessage:
                " Use a drag and drop form builder to build a custom intake process. Easily manage every new graphic request or media buy that comes your way."
        })
    };

    const withTemplates = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.withTemplates.strongtext",
            defaultMessage: "Get up and going with templates:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.withTemplates.plainText",
            defaultMessage:
                " 20+ new project templates make it easy for marketing teams to get started instantly, with no set-up required."
        })
    };

    const listItems = [
        ListItemWithEmphsis(manageProjects),
        ListItemWithEmphsis(customForm),
        ListItemWithEmphsis(withTemplates)
    ];
    const imageSrc =
        "https://wac-cdn.atlassian.com/dam/jcr:20b21854-ee52-497c-ab4d-151a9529af54/MARKETING%20CALENDAR@2x.png?cdnVersion=ece";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.tabsImageAltText",
        defaultMessage: "Marketing teams"
    });

    const testimony = {
        isIncludeTestimony: true,
        quoteBlurb: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.testimony.quoteBlurb",
            defaultMessage:
                "The easiest way for teams to handle event planning tasks - whether it’s talking to vendors, designing assets, or obtaining approvals."
        }),
        quoteName: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.testimony.quoteName",
            defaultMessage: "ROMAN BUGAEV"
        }),
        quoteCompany: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.testimony.quoteCompany",
            defaultMessage: "CTO, FLO"
        }),
        testimonyImageClassName: "tab-testimony-image",
        testimonyImageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:69bdf45e-4252-4997-8a45-80cd9f077694/LP-logos_flo%20logo.svg?cdnVersion=ece",
        testimonyImageAlt: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.marketingTeams.testimony.logo.imageAltText",
            defaultMessage: "Flo Logo"
        })
    };

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
            isIncludeTestimony={testimony.isIncludeTestimony}
            quoteBlurb={testimony.quoteBlurb}
            quoteName={testimony.quoteName}
            quoteCompany={testimony.quoteCompany}
            testimonyImageClassName={testimony.testimonyImageClassName}
            testimonyImageSrc={testimony.testimonyImageSrc}
            testimonyImageAlt={testimony.testimonyImageAlt}
        />
    );
};

export default MarketingTeams;
